function getNamesFromAjaxResponse(payload) {
	if (!payload || typeof payload !== 'object') return [];
	if (payload.success !== true) return [];
	if (payload.data && Array.isArray(payload.data.names)) return payload.data.names;
	return [];
}

function escapeHtml(value) {
	return (value || '')
		.toString()
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;')
		.replace(/'/g, '&#039;');
}

function addDescribedBy($input, id) {
	const existing = ($input.getAttribute('aria-describedby') || '').trim();
	const parts = existing ? existing.split(/\s+/) : [];
	if (!parts.includes(id)) {
		parts.push(id);
		$input.setAttribute('aria-describedby', parts.join(' ').trim());
	}
}

function removeDescribedBy($input, id) {
	const existing = ($input.getAttribute('aria-describedby') || '').trim();
	if (!existing) return;
	const parts = existing.split(/\s+/).filter(x => x && x !== id);
	if (parts.length) {
		$input.setAttribute('aria-describedby', parts.join(' '));
	} else {
		$input.removeAttribute('aria-describedby');
	}
}

function ensureWarningElement($input) {
	if (!$input.dataset.indivisibleGroupWarningId) {
		$input.dataset.indivisibleGroupWarningId = `indivisible-group-name-warning-${$input.id || Math.random().toString(36).slice(2)}`;
	}
	const warningId = $input.dataset.indivisibleGroupWarningId;
	let $warning = document.getElementById(warningId);
	if ($warning) return $warning;

	$warning = document.createElement('div');
	$warning.id = warningId;
	$warning.className = 'gfield_description validation_message gfield_validation_message indivisible-group-name-warning indivisible-group-name-warning--error';
	$warning.setAttribute('role', 'status');
	$warning.setAttribute('aria-live', 'polite');
	$warning.style.display = 'none';

	const $gfield = $input.closest('.gfield');
	const $container = $gfield ? ($gfield.querySelector('.ginput_container') || $gfield) : $input.parentElement;
	$container.appendChild($warning);

	return $warning;
}

function setWarningVisible($input, $warning, visible, message = '') {
	if (visible) {
		$warning.innerHTML = message;
		$warning.style.display = '';
		addDescribedBy($input, $warning.id);
	} else {
		$warning.innerHTML = '';
		$warning.style.display = 'none';
		removeDescribedBy($input, $warning.id);
	}
}

document.addEventListener('DOMContentLoaded', () => {
	const scripts = window?.fritzScripts;
	const config = scripts && scripts.groups;
	if (!scripts || !config) return;

	const ajaxurl = scripts.ajaxurl;
	const nonce = scripts.security;
	const action = 'indivisible_group_name_exists';
	const warningCopy = (config.warningCopy || 'A group with this name already exists.').toString();
	const minLen = Math.max(0, parseInt(config.minNameLength || 3, 10));

	const selector = '.js-group-name input';
	const formIds = Array.isArray(config.formIds)
		? config.formIds.map(x => parseInt(x, 10)).filter(x => Number.isFinite(x) && x > 0)
		: [];
	if (!ajaxurl || !nonce || !formIds.length) return;

	formIds.forEach(formId => {
		const $form = document.querySelector(`form#gform_${formId}`);
		if (!$form) return;

		const $input = $form.querySelector(selector);
		if (!$input) return;

		const $warning = ensureWarningElement($input);
		let abortController = null;

		const hideWarningOnType = () => {
			if (abortController) {
				abortController.abort();
				abortController = null;
			}
			setWarningVisible($input, $warning, false);
		};

		const runCheck = () => {
			const rawValue = ($input.value || '').trim();
			if (!rawValue || rawValue.length < minLen) {
				setWarningVisible($input, $warning, false);
				return;
			}

			if (abortController) {
				abortController.abort();
			}
			abortController = new AbortController();

			const body = new URLSearchParams();
			body.set('action', action);
			body.set('security', nonce);
			body.set('name', rawValue);

			fetch(ajaxurl, {
				method: 'POST',
				credentials: 'same-origin',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				},
				body,
				signal: abortController.signal,
			})
				.then(r => r.json())
				.then(payload => {
					const names = getNamesFromAjaxResponse(payload);
					if (!names.length) {
						setWarningVisible($input, $warning, false);
						return;
					}

					const groupName = escapeHtml(names[0] || '');
					const message = warningCopy.includes('{group}')
						? warningCopy.split('{group}').join(groupName)
						: warningCopy;

					setWarningVisible($input, $warning, true, message);
				})
				.catch(err => {
					if (err && err.name === 'AbortError') return;
					// Warning-only feature: fail silent and avoid blocking form use.
				});
		};

		// 1) Only trigger checks on exit from the field.
		$input.addEventListener('blur', runCheck);

		// 2) Hide immediately as user types; check again on exit.
		$input.addEventListener('input', hideWarningOnType);
	});
});
